// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-nested-ternary */
import React from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Auth0Provider } from '@auth0/auth0-react';
import { ROUTES } from 'routing/constants';

const Auth0ProviderWithHistory = ({ children }) => {
    const domain = process.env.REACT_APP_AUTH0_DOMAIN;
    const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
    const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
    const history = useHistory();

    const organization = window.localStorage.getItem('MP_AUTH0_ORGANIZATION');
    const connection =
        window.localStorage.getItem('MP_AUTH0_CONNECTION') ||
        window.localStorage.getItem('MP_ORGANIZATION');

    return (
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            redirectUri={window.location.origin}
            responseType="code"
            onRedirectCallback={() => history.push(ROUTES.base)}
            {...(organization
                ? { organization }
                : connection
                ? { connection }
                : {})}
            scope="openid profile email"
            audience={audience}
        >
            {children}
        </Auth0Provider>
    );
};

Auth0ProviderWithHistory.propTypes = {
    children: PropTypes.oneOfType([PropTypes.any]).isRequired,
};

export default Auth0ProviderWithHistory;
